<template>
  <div class="modal fade" id="notes-modal" tabindex="-1" aria-labelledby="notes-modal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('notes')}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
        </div>
        <div class="modal-body">
          <textarea v-model="notes" class="form-control" rows="5" placeholder="Enter your notes here..."></textarea>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{$t('cancel')}}</button>
          <button type="button" class="btn btn-primary" @click="saveNotes"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('save')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotesModal',
  props: {
    state: {
      type: Boolean,
      required: true
    },
    notes: {
      type: String,
      required: false,
      notes : ''
    }
  },
  data() {
    return {
      createModal: null
    };
  },
  mounted() {
    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('notes-modal'))
    if (this.state === true) {
      this.createModal.show()
    }

    document.getElementById('notes-modal').addEventListener('hidden.bs.modal', () => {
      this.$emit('saveNotes', { state: false })
    })
  },
  methods: {
    saveNotes() {
      this.$emit('saveNotes', {notes : this.notes} );
      this.createModal.hide();
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}
.modal {
  background: white;
  border-radius: 5px;
  max-width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.modal-header, .modal-footer {
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
}
.modal-header {
  border-bottom: none;
}
.modal-body {
  padding: 1rem;
}
</style>
